import { ZoomMeeting } from "~/providers/utils/types/zoomMeetingTypes";

const JOINABLE_ZOOM_MEETING_STATUSES = new Set(["SCHEDULED", "STARTED"]);

export const isZoomMeetingJoinable = (
  meeting: Pick<ZoomMeeting, "status" | "join_url">,
) => !!meeting.join_url && JOINABLE_ZOOM_MEETING_STATUSES.has(meeting.status);
